import { bucketActiveABTests } from 'dibs-ab-tests/exports/clientAbTestV2.ts';
import { AB_TEST_TYPES } from 'dibs-bucket-ab-tests';

// Buckets & fires the "ab_test_bucket" GA event for all page views
// for all active tests of the types passed
bucketActiveABTests([AB_TEST_TYPES.SELLER]);
